import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

export const textareaVariants = cva(
  [
    "flex min-h-[86px] w-full bg-white rounded-control border px-3 py-2.5",
    "text-control leading-relaxed text-neutral-900",
    "transition-colors placeholder:text-neutral-400",
    "disabled:cursor-not-allowed disabled:opacity-50",
  ].join(" "),
  {
    variants: {
      variant: {
        default: "border-neutral-200 hover:border-neutral-300",
        error: "border-danger-border text-danger-fg",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface TextareaProps
  extends
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(textareaVariants({ variant, className }))}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";

export { Textarea };
